(function () {
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  const fab = $('[data-a11y="open"]');
  const panel = $('#a11y-416-panel');
  const overlay = $('[data-a11y="overlay"]');
  const closeBtn = $('[data-a11y="close"]');
  const resetBtn = $('[data-a11y="reset"]');
  const hideBtn = $('[data-a11y="hide"]');

  if (!fab || !panel || !overlay || !closeBtn) return;

  const KEY = 'a11y416_settings_v1';

  const state = {
    text: 0, // 0 default, 1 lg, 2 xl
    contrast: false,
    links: false,
    focus: false,
    motion: false
  };

  function load() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return;
      const s = JSON.parse(raw);
      Object.assign(state, s || {});
    } catch(e){}
  }

  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch(e){}
  }

  function apply() {
    document.body.classList.toggle('a11y-contrast', !!state.contrast);
    document.body.classList.toggle('a11y-links', !!state.links);
    document.body.classList.toggle('a11y-focus', !!state.focus);
    document.body.classList.toggle('a11y-reduce-motion', !!state.motion);

    document.body.classList.remove('a11y-text-lg', 'a11y-text-xl');
    if (state.text === 1) document.body.classList.add('a11y-text-lg');
    if (state.text === 2) document.body.classList.add('a11y-text-xl');
  }

  // Focus trap
  let lastFocus = null;
  function getFocusable() {
    return $$('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(el => !el.disabled && el.offsetParent !== null);
  }

  function openPanel() {
    lastFocus = document.activeElement;
    fab.setAttribute('aria-expanded', 'true');
    overlay.hidden = false;
    panel.hidden = false;

    // focus first meaningful control
    const focusables = getFocusable();
    (focusables[0] || closeBtn).focus({preventScroll:true});

    document.addEventListener('keydown', onKeydown, true);
  }

  function closePanel() {
    fab.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    overlay.hidden = true;
    document.removeEventListener('keydown', onKeydown, true);

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({preventScroll:true});
    } else {
      fab.focus({preventScroll:true});
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closePanel();
      return;
    }

    if (e.key === 'Tab' && !panel.hidden) {
      const focusables = getFocusable();
      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function markPressed(btn, pressed) {
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
  }

  function wireToggle(selector, key) {
    const btn = $(`[data-a11y="${selector}"]`);
    if (!btn) return;

    markPressed(btn, !!state[key]);

    btn.addEventListener('click', () => {
      state[key] = !state[key];
      markPressed(btn, !!state[key]);
      apply();
      save();
    });
  }

  // Text controls
  const textPlus = $('[data-a11y="text-plus"]');
  const textMinus = $('[data-a11y="text-minus"]');

  if (textPlus) {
    textPlus.addEventListener('click', () => {
      state.text = Math.min(2, state.text + 1);
      apply();
      save();
    });
  }
  if (textMinus) {
    textMinus.addEventListener('click', () => {
      state.text = Math.max(0, state.text - 1);
      apply();
      save();
    });
  }

  wireToggle('contrast', 'contrast');
  wireToggle('links', 'links');
  wireToggle('focus', 'focus');
  wireToggle('motion', 'motion');

  // Profiles
  $$('[data-profile]').forEach(btn => {
    btn.addEventListener('click', () => {
      const p = btn.getAttribute('data-profile');

      // Start from clean base
      state.text = 0;
      state.contrast = false;
      state.links = false;
      state.focus = true;      // always helpful
      state.motion = false;

      if (p === 'seizure') {
        state.motion = true;
        state.contrast = true;
      } else if (p === 'vision') {
        state.text = 2;
        state.contrast = true;
        state.links = true;
        state.focus = true;
      } else if (p === 'adhd') {
        state.motion = true;
        state.text = 1;
        state.focus = true;
      } else if (p === 'cognitive') {
        state.text = 1;
        state.links = true;
        state.focus = true;
      }

      // Re-sync aria-pressed on toggles
      $$('[data-a11y]').forEach(el => {
        const k = el.getAttribute('data-a11y');
        if (k === 'contrast') el.setAttribute('aria-pressed', state.contrast ? 'true' : 'false');
        if (k === 'links') el.setAttribute('aria-pressed', state.links ? 'true' : 'false');
        if (k === 'focus') el.setAttribute('aria-pressed', state.focus ? 'true' : 'false');
        if (k === 'motion') el.setAttribute('aria-pressed', state.motion ? 'true' : 'false');
      });

      apply();
      save();
    });
  });

  // Reset
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      state.text = 0;
      state.contrast = false;
      state.links = false;
      state.focus = false;
      state.motion = false;

      $$('[data-a11y]').forEach(el => {
        const k = el.getAttribute('data-a11y');
        if (k === 'contrast' || k === 'links' || k === 'focus' || k === 'motion') {
          el.setAttribute('aria-pressed', 'false');
        }
      });

      apply();
      save();
    });
  }

  // Hide panel (but keep button)
  if (hideBtn) {
    hideBtn.addEventListener('click', () => closePanel());
  }

  // Open/close actions
  fab.addEventListener('click', openPanel);
  closeBtn.addEventListener('click', closePanel);
  overlay.addEventListener('click', closePanel);

  // Init
  load();
  apply();

  // Accessibility: ensure button never sits behind reCAPTCHA
  // (If your reCAPTCHA badge is in another corner, adjust CSS bottom/right.)
})();
